import { JiraFilterAri } from '@atlassian/ari/jira/filter';
import RelayDataID from '@atlassian/relay-data-id';
var isCustomFilter = function isCustomFilter(filterId) {
  return /^\d+$/.test(filterId);
};
var isSystemFilter = function isSystemFilter(filterId) {
  return /^-\d+$/.test(filterId);
};
export var JiraQueryFilterMissingFieldHandler = {
  handle: function handle(field, record, argValues) {
    // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/

    // This lets relay know that a query of
    // JiraQuery.filter(id: ID!)
    // can return:
    //   - a JiraCustomFilter object
    //   - a JiraSystemFilter object
    // determined by the type encoded within the id field (which is an ARI type).
    // By providing the id that relay would refer to those objects by, it is able to check it's
    // store to see if they are already fetched, and avoid refetching them if it is unnecessary
    if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
      var id = argValues.id;
      var filterId = JiraFilterAri.parse(id).filterId;
      if (isCustomFilter(filterId)) {
        return RelayDataID({
          id: id
        }, 'JiraCustomFilter');
      }
      if (isSystemFilter(filterId)) {
        return RelayDataID({
          id: id
        }, 'JiraSystemFilter');
      }
      return undefined;
    }
    return undefined;
  },
  kind: 'linked'
};
var MissingFieldHandlers = [JiraQueryFilterMissingFieldHandler];
export default MissingFieldHandlers;